<template>
    <div class="form-group has-effect" :class="[{ 'is-invalid': invalid }, { disabled: disabled }]">
        <div class="has-effect-input" style="pointer-events: none">
            <input
                type="text"
                autocomplete="off"
                style="pointer-events: all"
                class="form-control"
                :class="[
                    { 'has-content': val || hasContent },
                    { 'is-invalid': invalid }
                ]"
                :tabindex="tabindex"
                :id="id"
                :disabled="disabled"
            />
            <span class="form-label">
                <span v-if="placeholder" v-text="placeholder" />
                <span v-if="required" v-text="'*'" class="text-danger pl-1" />
            </span>
            <div class="litepicker-backdrop" style="display: none"></div>
        </div>
        <div v-if="invalid" class="invalid-feedback">{{ invalid }}</div>
    </div>
</template>

<script>
import moment from 'moment'
import Litepicker from 'litepicker'

export default {
    data() {
        return {
            dates: null,
            elem: null,
            hasContent: false
        }
    },
    props: {
        placeholder: {
            type: String,
            required: false
        },
        id: {
            type: String,
            required: false
        },
        lockFutureDays: {
            type: Array,
            require: false
        },
        lockPastDays: {
            type: Array,
            require: false
        },
        val: {
            type: String,
            require: false
        },
        tabindex: {
            type: Number,
            default: 0
        },
        withTime: {
            type: Boolean,
            default: false
        },
        invalid: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.setDataPicker()
    },
    computed: {
        lockFutureDay() {
            if (!this.lockFutureDays) return
            const validDates = this.lockFutureDays.filter(
                date => date !== '' && typeof date !== 'undefined'
            )
            if (validDates.length === 0) return
            const momentDates = validDates.map(date => moment(date))
            const earliestDate = moment.min(momentDates)
            return earliestDate
        },
        lockPastDay() {
            if (!this.lockPastDays) return
            const validDates = this.lockPastDays.filter(
                date => date !== '' && typeof date !== 'undefined'
            )
            if (validDates.length === 0) return
            const momentDates = validDates.map(date => moment(date))
            const latestDate = moment.max(momentDates)
            return latestDate
        },
        setLockFutureDays() {
            return [
                moment(this.lockFutureDay).add(1, 'days'),
                moment(this.lockFutureDay).add(100, 'years')
            ]
        },
        setLockPastDays() {
            return [
                moment(this.lockPastDay).subtract(100, 'years'),
                moment(this.lockPastDay).subtract(1, 'days')
            ]
        },
        setLockDays() {
            const lockDays = []
            if (this.lockFutureDay) {
                lockDays.push(this.setLockFutureDays)
            }
            if (this.lockPastDay) {
                lockDays.push(this.setLockPastDays)
            }
            return lockDays
        }
    },
    methods: {
        setDataPicker() {
            /* eslint-disable no-unused-vars */
            const context = this
            const settings = {
                lang: 'pl-PL',
                format: 'DD-MM-YYYY',
                showTooltip: false,
                singleMode: true
            }

            const element = document.querySelector(`#${this.id}`)
            let selectedDate
            if (element) {
                const modalOverlay = document.querySelector('.modal-base')
                const reportsStatusEndPicker = new Litepicker({
                    element,
                    parentEl: modalOverlay || document.body,
                    setup: picker => {
                        picker.on('show', () => {
                            context.hasContent = true
                        })

                        picker.on('selected', date => {
                            const currentDate = new Date()
                            const hours = context.withTime
                                ? currentDate.getHours()
                                : 0
                            const minutes = context.withTime
                                ? currentDate.getMinutes()
                                : 0
                            const seconds = context.withTime
                                ? currentDate.getSeconds()
                                : 0
                            selectedDate = moment(date.dateInstance)
                                .set('hour', hours)
                                .set('minute', minutes)
                                .set('second', seconds)
                                .format('DD-MM-YYYY HH:mm:ss')
                        })
                        picker.on('hide', () => {
                            context.hasContent = false
                            if (!selectedDate) return
                            context.$emit(
                                'change',
                                `${moment
                                    .utc(selectedDate, 'DD-MM-YYYY HH:mm:ss')
                                    .format('YYYY-MM-DD HH:mm:ss')}`
                            )
                        })
                    },
                    singleMode: true,
                    lockDaysFormat: 'DD-MM-YYYY',
                    lockDays: context.setLockDays,
                    ...settings
                })
                this.elem = reportsStatusEndPicker
                this.setDateValue()
            }
        },
        setDateValue() {
            if (this.val) {
                this.elem.setDate(this.val)
            } else {
                this.elem.clearSelection()
            }
        }
    },
    watch: {
        val() {
            this.setDateValue()
        },
        lockFutureDay() {
            this.elem.setLockDays(this.setLockDays)
        },
        lockPastDay() {
            this.elem.setLockDays(this.setLockDays)
        }
    },
    beforeDestroy() {
        this.elem.destroy()
    }
}
</script>
